import { freeze } from 'icepick';
import { SET_CONTEXT } from './context-action-type.tsx';
import type { ContextType } from './context-type.tsx';

const initialState: ContextType = freeze({
	rapidViewId: undefined,
	currentLocation: undefined,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const contextReducer = (state: ContextType = initialState, action: any) => {
	const { type, payload } = action;

	switch (type) {
		case SET_CONTEXT:
			return freeze(payload);
		default:
			return state;
	}
};

export default contextReducer;
